<template>

    <div class="bootstrap modal-content">
      <div class="modal-header">
        <h5 class="modal-title">RMS 담당자 등록</h5>
        <button type="button" class="close" @click="$emit('dismiss')">X</button>
      </div>
      <div class="modal-body p-3">
        <el-row :gutter="10">
          <el-col :span="24" class="text-right">
            <el-button type="primary" @click="insert">담당자 추가</el-button>
          </el-col>
        </el-row>

      <el-row :gutter="10">
      <el-col :span="24" class="mt-2">
        <el-table class="table-striped"
                  border
                  style="width: 100%; margin-bottom: 10px"
                  :data="$store.state.rmsDamdang.items"
                  ref="contractsTable"
                  :header-cell-style="tableRowStyle">
          <el-table-column
            prop="damdangName"
            label="담당자명">
          </el-table-column>
          <el-table-column
            prop="phone"
            label="연락처">
          </el-table-column>
          <el-table-column
            prop="email"
            label="이메일">
          </el-table-column>

          <!-- <el-table-column
            label="사용중">
            <template slot-scope="{row}">
              <i v-if="row.deleteYn === 'N'" class="el-icon-check text-success fs18"></i>
              <i v-if="row.deleteYn === 'Y'" class="el-icon-close text-danger fs18"></i>
            </template>
          </el-table-column> -->

          <el-table-column
            width="120"
            v-if="$store.state.account.roleCode === 'ADMIN' || $store.state.modusign.contractDownload"
            label="수정/삭제">
            <template slot-scope="props">
              <el-button size="small" title="수정"  icon="el-icon-edit-outline" @click="edit(props.row)"></el-button>
              <el-button size="small" title="삭제" type="danger" icon="el-icon-delete-solid" @click="remove(props.row.id)"></el-button>
            </template>
          </el-table-column>
        </el-table>
      </el-col>
      </el-row>


      </div>
      <div class="modal-footer">
            <el-button @click="$emit('dismiss')">닫 기</el-button>
      </div>
    </div>

</template>

<script>

import RmsDamdangFormModalVue from './RmsDamdangFormModal.vue';

export default {
    created() {
        this.getList()
    },
    props: {
        handler: {
            type: Function
        }
    },
    data() {
      return {
      }
    },    
    methods: {
        tableRowStyle() {
            return this.$store.state.common.tableHeaderCellStyle;
        },
        insert() {

          this.$modal.show(
            RmsDamdangFormModalVue,
            { mode: 'insert', handler: this.insertRmsDamdang },
            { width:'500px' },
            { }
          ).result.then( data =>{
            return this.insertRmsDamdang( data )
          }).then(this.getList)


          
        },
        insertRmsDamdang( data ) {

          return this.$store.dispatch('rmsDamdang/create', data)

        },
        updateRmsDamdang( data ) {
          return this.$store.dispatch('rmsDamdang/update', data)

        },
        remove( id ) {
          if(confirm('삭제 하시겠습니까?')) {
            this.$store.dispatch('rmsDamdang/destroy', id)
            .then(()=>{
              alert('삭제 되었습니다.')
              this.getList()
            })  
          }  
        },
        edit( item ) {

          this.$modal.show(
            RmsDamdangFormModalVue,
            { mode: 'update', data: item },
            { width:'500px' },
            { }
          ).result.then( data =>{
            return this.updateRmsDamdang( data )
          }).then(this.getList)

          
        },
        getList() {

          this.$store.dispatch('rmsDamdang/getList')

            
        }
    },

}
</script>